import { Node, mergeAttributes } from '@tiptap/core';
const TuiMention = Node.create({
  name: 'mention',
  group: 'inline',
  inline: true,
  selectable: true,
  atom: true,
  addOptions() {
    return {
      HTMLAttributes: {},
      renderHTML({
        node
      }) {
        return ['span', this.HTMLAttributes, `@${node.attrs.label ?? node.attrs.id}`.replaceAll(/@+/g, '@')];
      }
    };
  },
  addAttributes() {
    return {
      id: {
        default: null,
        keepOnSplit: true,
        parseHTML: element => element.innerText,
        renderHTML: () => ({
          'data-type': this.name
        })
      },
      class: {
        default: null,
        keepOnSplit: true
      }
    };
  },
  parseHTML() {
    return [{
      tag: `span[data-type="${this.name}"]`
    }];
  },
  renderHTML({
    node,
    HTMLAttributes
  }) {
    const html = this.options.renderHTML({
      options: this.options,
      node
    });
    if (typeof html === 'string') {
      return ['span', mergeAttributes({
        'data-type': this.name
      }, this.options.HTMLAttributes, HTMLAttributes), html];
    }
    return ['span', mergeAttributes({
      'data-type': this.name
    }, this.options.HTMLAttributes, HTMLAttributes), html?.[2]];
  }
});

/**
 * Generated bundle index. Do not edit.
 */

export { TuiMention };
